/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Detail units constants
 */

export const START_FETCHING_UNITS = '@@nzr/Detail/START_FETCHING_UNITS'
export const CLEAR_UNITS = '@@nzr/Detail/CLEAR_UNITS'
export const DONE_FETCHING_UNITS = '@@nzr/Detail/DONE_FETCHING_UNITS'
export const ERROR_FETCHING_UNITS = '@@nzr/Detail/ERROR_FETCHING_UNITS'
export const RECEIVE_UNITS = '@@nzr/Detail/RECEIVE_UNITS'
